import { statesAU } from './states-au';

// operators
export const OPERATOR_EQUALS = 'equals';
export const OPERATOR_NOT_EQUALS = 'does not equal';
export const OPERATOR_CONTAINS = 'contains';
export const OPERATOR_DOES_NOT_CONTAIN = 'does not contain';
export const OPERATOR_BEGINS_WITH = 'begins with';
export const OPERATOR_ENDS_WITH = 'ends with';
export const OPERATOR_IS_EMPTY = 'is empty';
export const OPERATOR_IS_NOT_EMPTY = 'is not empty';
export const OPERATOR_GREATER_THAN = 'greater than';
export const OPERATOR_LESS_THAN = 'less than';
export const OPERATOR_GREATER_THAN_EQUAL = 'greater than or equal to';
export const OPERATOR_LESS_THAN_EQUAL = 'less than or equal to';

export const OPERATORS = [
    OPERATOR_EQUALS,
    OPERATOR_NOT_EQUALS,
    OPERATOR_CONTAINS,
    OPERATOR_DOES_NOT_CONTAIN,
    OPERATOR_BEGINS_WITH,
    OPERATOR_ENDS_WITH,
    OPERATOR_IS_EMPTY,
    OPERATOR_IS_NOT_EMPTY,
    OPERATOR_GREATER_THAN,
    OPERATOR_LESS_THAN,
    OPERATOR_GREATER_THAN_EQUAL,
    OPERATOR_LESS_THAN_EQUAL,
];

export const defaultSegment = () => {
    return {
        name: null,
        criteria: {
            logicalOperator: 'and',
            children: [],
        },
    };
};

export const distributionListSegmentRules = () => {
    return [
        {
            type: 'text',
            id: 'first_name',
            label: 'First name',
            operators: [
                OPERATOR_EQUALS,
                OPERATOR_NOT_EQUALS,
                OPERATOR_CONTAINS,
                OPERATOR_DOES_NOT_CONTAIN,
                OPERATOR_BEGINS_WITH,
                OPERATOR_ENDS_WITH,
                OPERATOR_IS_EMPTY,
                OPERATOR_IS_NOT_EMPTY,
            ],
        },
        {
            type: 'text',
            id: 'last_name',
            label: 'Last name',
            operators: [
                OPERATOR_EQUALS,
                OPERATOR_NOT_EQUALS,
                OPERATOR_CONTAINS,
                OPERATOR_DOES_NOT_CONTAIN,
                OPERATOR_BEGINS_WITH,
                OPERATOR_ENDS_WITH,
                OPERATOR_IS_EMPTY,
                OPERATOR_IS_NOT_EMPTY,
            ],
        },
        {
            type: 'text',
            id: 'email',
            label: 'Email',
            operators: [
                OPERATOR_EQUALS,
                OPERATOR_CONTAINS,
                OPERATOR_BEGINS_WITH,
                OPERATOR_ENDS_WITH,
            ],
        },
        {
            type: 'numeric',
            id: 'address_street_no',
            label: 'Street number',
            operators: [
                OPERATOR_EQUALS,
                OPERATOR_NOT_EQUALS,
                OPERATOR_CONTAINS,
                OPERATOR_DOES_NOT_CONTAIN,
                OPERATOR_BEGINS_WITH,
                OPERATOR_ENDS_WITH,
                OPERATOR_IS_EMPTY,
                OPERATOR_IS_NOT_EMPTY,
                OPERATOR_GREATER_THAN,
                OPERATOR_LESS_THAN,
                OPERATOR_GREATER_THAN_EQUAL,
                OPERATOR_LESS_THAN_EQUAL,
            ],
        },
        {
            type: 'text',
            id: 'address_street_name',
            label: 'Street name',
            operators: [
                OPERATOR_EQUALS,
                OPERATOR_NOT_EQUALS,
                OPERATOR_CONTAINS,
                OPERATOR_BEGINS_WITH,
                OPERATOR_ENDS_WITH,
                OPERATOR_IS_EMPTY,
                OPERATOR_IS_NOT_EMPTY,
            ],
        },
        {
            type: 'text',
            id: 'address_suburb',
            label: 'Suburb',
            operators: [
                OPERATOR_EQUALS,
                OPERATOR_NOT_EQUALS,
                OPERATOR_CONTAINS,
                OPERATOR_BEGINS_WITH,
                OPERATOR_ENDS_WITH,
                OPERATOR_IS_EMPTY,
                OPERATOR_IS_NOT_EMPTY,
            ],
        },
        {
            type: 'select',
            id: 'address_state',
            label: 'State',
            choices: [...statesAU()],
        },
        {
            type: 'numeric',
            id: 'address_postcode',
            label: 'Postcode',
            operators: [
                OPERATOR_EQUALS,
                OPERATOR_NOT_EQUALS,
                OPERATOR_CONTAINS,
                OPERATOR_BEGINS_WITH,
                OPERATOR_ENDS_WITH,
                OPERATOR_IS_EMPTY,
                OPERATOR_IS_NOT_EMPTY,
                OPERATOR_GREATER_THAN,
                OPERATOR_LESS_THAN,
                OPERATOR_GREATER_THAN_EQUAL,
                OPERATOR_LESS_THAN_EQUAL,
            ],
        },
    ];
};

export const distributionListSegmentsLabels = () => {
    return {
        matchType: 'Match Type',
        matchTypes: [
            { id: 'and', label: 'And' },
            { id: 'or', label: 'Or' },
        ],
        addRule: '+ Add Rule',
        removeRule: '&times;',
        addGroup: '+ Add Group',
        removeGroup: '&times;',
        textInputPlaceholder: 'value',
    };
};